import {useEffect, useState} from "react";
import {useErrorHandling} from "context/errorHandling";
import {fetchContractorUpdateHistory} from "services/ContractorService";

export const useContractorUpdateHistory = (contractorId) => {
    const [updateHistory, setUpdateHistory] = useState()
    const [loading, setLoading] = useState(false)
    const {handleError} = useErrorHandling()

    useEffect(() => {
        setLoading(true)
        fetchContractorUpdateHistory(contractorId)
            .then(records => setUpdateHistory(records))
            .catch(handleError)
            .then(() => setLoading(false))
    }, [contractorId, handleError])

    return {
        updateHistory,
        updateHistoryLoading: loading
    }
}